import Accordion from '../components/Accordion';

export default class CategoryBrowse {
    constructor() {
        this.initialiseAccordion();
    }

    initialiseAccordion() {
        const accordion = new Accordion(
            '[data-grouped-categories-selector] [data-accordion]',
            (triggerEl) => this.deactivateActiveAccordionItemSiblings(accordion, triggerEl)
        );
    }

    deactivateActiveAccordionItemSiblings(accordion, triggerEl) {
        const mediumNormalBreakpointEdge = 900;
        const isWideScreen = window.innerWidth >= mediumNormalBreakpointEdge;
        const parent = triggerEl.parentNode;

        accordion.$items.filter('[data-active="true"]').each((index, item) => {
            if (isWideScreen && item !== parent) {
                accordion.deactivateItem(item);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./js/marketing/components/CategoryBrowse.js